<template>
  <div class="login-main">
    <nav-bar @sendDefaultAddress="getAddress" :checkpage="page" ref="getaddressdata"></nav-bar>
    <section class="review-order-start review-order-start-new">
      <div class="review-container review-main text-capitalize position-relative review-container-nw fixbottom-sticky">
        <lottie-animation ref="anim" :animationData="require('@/assets/animation.json')" class="animationCls"
          v-if="isAnimation" />
        <div class="row" v-if="cartItemCount > 0">
          <div class="col-md-12 p-0">
            <div class="back-menu">
              <a @click="redirectRestaurant" class="resst-lnk mouse-hover">Back to menu</a>
            </div>
            <div class="resturant-details d-flex align-items-start plr15 fullres-head">
              <div class="rst-nme-add">
                <h4 class="mt-0 mb-1 mb-lg-0">
                  {{ $t("Your Cart") }}
                  <span class="total-items">({{ cart.reduce((a, c) => a + c.quantity, 0) }}
                    {{
                      cart.reduce((a, c) => a + c.quantity, 0) > 1
                        ? $t("Items")
                        : $t("Item")
                    }})</span>
                </h4>
                <p class="frm-txt mb-1">
                  {{ $t("From") }} :
                  <a href="javascript:void(0)" v-if="!restaurantData.slug">
                    <skeleton-loader-vue type="string" width="50%" height="20px" />
                  </a>
                  <a v-else @click="redirectRestaurant" class="resst-lnk mouse-hover">{{ this.restaurantData.name }}</a>
                </p>
              </div>
              <div class="">
                <svg class="mouse-hover" @click="clearCartItem" fill="#EF2121" version="1.1" id="Capa_1"
                  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20px"
                  viewBox="0 0 482.428 482.429" xml:space="preserve" stroke="#EF2121">
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <g>
                      <g>
                        <path
                          d="M381.163,57.799h-75.094C302.323,25.316,274.686,0,241.214,0c-33.471,0-61.104,25.315-64.85,57.799h-75.098 c-30.39,0-55.111,24.728-55.111,55.117v2.828c0,23.223,14.46,43.1,34.83,51.199v260.369c0,30.39,24.724,55.117,55.112,55.117 h210.236c30.389,0,55.111-24.729,55.111-55.117V166.944c20.369-8.1,34.83-27.977,34.83-51.199v-2.828 C436.274,82.527,411.551,57.799,381.163,57.799z M241.214,26.139c19.037,0,34.927,13.645,38.443,31.66h-76.879 C206.293,39.783,222.184,26.139,241.214,26.139z M375.305,427.312c0,15.978-13,28.979-28.973,28.979H136.096 c-15.973,0-28.973-13.002-28.973-28.979V170.861h268.182V427.312z M410.135,115.744c0,15.978-13,28.979-28.973,28.979H101.266 c-15.973,0-28.973-13.001-28.973-28.979v-2.828c0-15.978,13-28.979,28.973-28.979h279.897c15.973,0,28.973,13.001,28.973,28.979 V115.744z">
                        </path>
                        <path
                          d="M171.144,422.863c7.218,0,13.069-5.853,13.069-13.068V262.641c0-7.216-5.852-13.07-13.069-13.07 c-7.217,0-13.069,5.854-13.069,13.07v147.154C158.074,417.012,163.926,422.863,171.144,422.863z">
                        </path>
                        <path
                          d="M241.214,422.863c7.218,0,13.07-5.853,13.07-13.068V262.641c0-7.216-5.854-13.07-13.07-13.07 c-7.217,0-13.069,5.854-13.069,13.07v147.154C228.145,417.012,233.996,422.863,241.214,422.863z">
                        </path>
                        <path
                          d="M311.284,422.863c7.217,0,13.068-5.853,13.068-13.068V262.641c0-7.216-5.852-13.07-13.068-13.07 c-7.219,0-13.07,5.854-13.07,13.07v147.154C298.213,417.012,304.067,422.863,311.284,422.863z">
                        </path>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
            </div>
            <div class="order-items-main plr15">
              <div class="order-item d-flex align-items-start justify-content-between"
                v-for="(item, index) in filterCart" :key="index">
                <div class="item-heading-main">
                  <div class="crt-img crt-img-nw" :class="item.image == '' || item.image == null ? 'noimg' : 'noimg'
                    ">
                    <div class="veg veg-non-nw" v-if="item.item_type == '0'">
                      <span></span>
                    </div>
                    <div class="non-veg veg-non-nw" v-if="item.item_type == '1'">
                      <img class="non-veg-img" src="@/assets/images/non_veg.png" />
                    </div>
                  </div>
                  <div class="item-heading item-heading-nw">
                    <p class="mb-0">{{ item.name }} :</p>
                    <div class="subname" v-if="item.selected_type.length > 0">
                      <span v-for="(subitem, i) in item.selected_type" :key="i">{{ subitem }}
                        <span v-if="i != Object.keys(item.selected_type).length - 1">,</span>
                      </span>
                    </div>
                    <p class="mb-0"><span id="currency" v-html="$auth.setting.currency" class="currency"></span>{{ unitPrice(item) }}</p>
                  </div>
                </div>
                <div class="d-flex flex-column align-items-center text-right justify-content-center mobiitem-nw">
                  <div class="number d-flex align-items-start counter-nw">
                    <span v-if="
                      Number(item.total_price) > 0 || (freeBieCoupon && item.promocode_id == freeBieCoupon.id)"
                      class="minus d-flex justify-content-center align-items-center"
                      @click="minusItem(item, index)">-</span>
                    <span v-else class="minus disable d-flex justify-content-center align-items-center">-</span>
                    <input type="text" :value="item.quantity" readonly />
                    <span v-if="Number(item.total_price) > 0"
                      class="plus d-flex justify-content-center align-items-center"
                      @click="plusItem(item, index)">+</span>
                    <span v-else class="plus d-flex justify-content-center align-items-center"
                      :class="(freeBieCoupon && item.promocode_id != freeBieCoupon.id) ? 'disable' : ''">+</span>
                  </div>
                  <div class="final-item-price final-item-price-nw">
                    <p class="mb-0" v-if="Number(item.total_price) > 0">
                      <span id="currency" v-html="$auth.setting.currency" class="currency"></span>{{ item.total_price }}
                    </p>

                    <p class="mb-0" v-else style="color: #27ae60">
                      <span>{{ $t("Free") }}</span>
                    </p>
                    <p class="mb-0" v-if="item.total_price < item.price * item.quantity">
                      <del>
                        <span id="currency" v-html="$auth.setting.currency" class="currency"></span>{{ item.price *
                          item.quantity }}
                      </del>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <section v-if="
              freeBie &&
              freeBie.length > 0 &&
              freeBieCoupon != '' &&
              showFreeBie
            " class="reviewCart">
              <div class="media-itms media-itms-theme1 review-boxs">
                <h6 class="mb-2">{{ $t("Claim your free item") }}</h6>
                <Product :key="freeBie[0].item_id" :item="freeBie[0]" :right="true"
                  :menuId="freeBie[0].restaurant_menu_id" v-on:openProductDetailModal="openProductDeails"
                  :restaurantID="freeBie[0].restaurant_id" :class="freeBie[0].item_id" :pagename="'itemslist'"
                  :itemlayout="'1'" :freeBie="true" @hideFreeBei="hideFreeBie"></Product>
              </div>
            </section>
            <div class="plr15 review-section">
              <div class="review-boxs mt-4">
                <h6 class="mb-2">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1_13618)">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M17.6015 0.517605C16.9827 0.804386 16.2761 1.12984 16.0311 1.24084C15.7862 1.35189 15.1429 1.64715 14.6015 1.89709C14.06 2.14698 13.5931 2.36171 13.5637 2.37423C13.5343 2.38679 13.4342 2.27171 13.3412 2.11857C13.2481 1.96543 13.026 1.70242 12.8476 1.53409C11.3404 0.112183 8.95053 0.723339 8.26461 2.7061C8.15783 3.01473 8.13884 3.14626 8.14081 3.56289C8.14236 3.88642 8.17039 4.14343 8.22252 4.31289C8.26616 4.45468 8.31294 4.61415 8.32653 4.66726C8.34875 4.7544 8.10322 4.87731 5.80442 5.92993C4.40375 6.57132 3.2023 7.13392 3.13456 7.18014C2.98161 7.28453 2.85927 7.53451 2.85927 7.74259C2.85927 8.13034 3.22231 8.45893 3.60927 8.42129C3.76189 8.40648 5.91256 7.44015 11.3905 4.92503C15.5542 3.01332 19.0503 1.40621 19.1597 1.35362C19.4074 1.23451 19.5525 1.036 19.5818 0.776167C19.6266 0.378199 19.35 0.0481986 18.9431 0.0142611C18.748 -0.00200448 18.6148 0.0479174 17.6015 0.517605ZM10.6171 2.2006C10.2143 2.29914 9.82555 2.63003 9.65005 3.02382C9.5262 3.30175 9.50741 3.78864 9.61184 4.01345L9.67958 4.15932L10.8983 3.59964C11.5686 3.29181 12.1363 3.02134 12.1597 2.9986C12.185 2.97404 12.1514 2.88034 12.0768 2.76756C11.7756 2.3124 11.1514 2.06996 10.6171 2.2006ZM18.2652 3.09639C17.6053 3.20715 16.9981 3.50706 16.6943 3.8724C16.3618 4.2722 16.152 4.89896 16.0997 5.64882C16.0273 6.68589 15.829 6.91281 14.8967 7.02531C14.6617 7.05367 14.4879 7.10293 14.3986 7.1665C13.9761 7.46734 14.0419 8.14337 14.5154 8.36809C14.8167 8.51106 15.6301 8.39701 16.2154 8.12973C16.976 7.78234 17.3855 7.07786 17.4878 5.94071C17.5655 5.07775 17.6999 4.74967 18.0331 4.61045C18.1201 4.57412 18.3915 4.51436 18.6362 4.4776C19.161 4.39881 19.3182 4.30632 19.4315 4.0096C19.5304 3.75085 19.4954 3.52665 19.3244 3.3235C19.1047 3.06235 18.825 3.0024 18.2652 3.09639ZM22.484 3.09639C21.824 3.20715 21.2169 3.50706 20.913 3.8724C20.5805 4.2722 20.3707 4.89896 20.3184 5.64882C20.2461 6.68589 20.0478 6.91281 19.1155 7.02531C18.8805 7.05367 18.7066 7.10293 18.6173 7.1665C18.1949 7.46734 18.2606 8.14337 18.7341 8.36809C19.0355 8.51106 19.8489 8.39701 20.4341 8.12973C21.1947 7.78234 21.6042 7.07786 21.7065 5.94071C21.7842 5.07775 21.9187 4.74967 22.2519 4.61045C22.3388 4.57412 22.6102 4.51436 22.8549 4.4776C23.3798 4.39881 23.537 4.30632 23.6503 4.0096C23.7491 3.75085 23.7141 3.52665 23.5432 3.3235C23.3234 3.06235 23.0438 3.0024 22.484 3.09639ZM1.51634 9.93329C0.825314 10.1311 0.25386 10.7166 0.0726416 11.4126C-0.113874 12.1288 0.0890009 13.1393 0.562345 13.8519C1.04525 14.579 1.93934 15.222 2.65363 15.356L2.81239 15.3858V18.1013C2.81239 21.0663 2.82303 21.2105 3.0883 21.845C3.42753 22.6564 4.14031 23.3702 4.95828 23.7177C5.64641 24.01 5.40645 24.0004 11.9999 24.0004C17.2886 24.0004 18.0469 23.9916 18.3651 23.9263C19.755 23.6414 20.8284 22.568 21.1133 21.1781C21.1758 20.8733 21.1874 20.3927 21.1874 18.1013V15.3858L21.3632 15.3534C21.4599 15.3356 21.6765 15.2635 21.8445 15.1932C22.8651 14.7665 23.7 13.7674 23.9055 12.7269C23.9361 12.5723 23.9804 12.4091 24.0039 12.3643C24.0586 12.2604 24.0604 11.5645 24.0059 11.5982C23.9834 11.6122 23.9534 11.5524 23.9393 11.4654C23.8661 11.0143 23.4259 10.4169 22.9619 10.1391C22.4343 9.82314 23.2128 9.84381 11.9783 9.84746C2.41367 9.85061 1.78733 9.85576 1.51634 9.93329ZM1.79525 11.3479C1.57531 11.4568 1.40614 11.7357 1.40614 11.9895C1.40614 12.6702 1.87606 13.4537 2.47616 13.7735C2.62963 13.8553 2.76805 13.9223 2.7838 13.9223C2.7995 13.9223 2.81239 13.3211 2.81239 12.5863V11.2504L2.40224 11.2504C2.08133 11.2504 1.94924 11.2717 1.79525 11.3479ZM4.21864 15.959C4.21864 19.2691 4.2343 20.7414 4.27138 20.9161C4.39278 21.4877 4.83763 22.0799 5.33506 22.332C5.87413 22.6052 5.59513 22.5941 11.984 22.5941C16.155 22.5941 17.9266 22.5789 18.1031 22.5414C18.6747 22.42 19.2669 21.9752 19.519 21.4777C19.7891 20.9447 19.7811 21.1111 19.7811 15.9749V11.2504H11.9999H4.21864V15.959ZM21.1874 12.5863C21.1874 13.3211 21.1986 13.9223 21.2124 13.9223C21.2262 13.9223 21.3456 13.8674 21.478 13.8003C21.9747 13.5487 22.4196 12.9561 22.5409 12.3848C22.6163 12.0299 22.6068 11.8697 22.4971 11.643C22.3567 11.353 22.1207 11.2504 21.5945 11.2504H21.1874V12.5863ZM0.0162509 12.0004C0.0162509 12.2195 0.0243603 12.3092 0.034204 12.1996C0.0440947 12.0901 0.0440947 11.9108 0.034204 11.8012C0.0243603 11.6916 0.0162509 11.7812 0.0162509 12.0004Z"
                        fill="black" />
                    </g>
                    <defs>
                      <clipPath id="clip0_1_13618">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  &nbsp;{{ $t("Add cooking notes") }}
                </h6>
                <!-- <input class="form-control mb-0 h50 line-input" type="search" :placeholder="$t('If you have any special instructions for this order, Please type here')" aria-label="instructions" v-model="instructions" /> -->
                <textarea rows="2" class="form-control mb-0 line-textarea" type="search" :placeholder="$t(
                  'If you have any special instructions for this order, Please type here'
                )
                  " aria-label="instructions" v-model="notes" />
              </div>

              <div class="review-boxs mt-4 promocode-sec" :class="verified_data?.calculation?.item_discount_excluding_freebie <=
                0
                ? ''
                : 'offers-boxs'
                ">
                <h6 class="mb-2">{{ $t("Offers") }}</h6>
                <a href="javascript:void(0)" @click="promocodeModal" class="offer-btn">{{ $t("View Offers")
                  }}</a>

                <input class="form-control mb-0 h50 line-input" :class="verified_data?.calculation
                  ?.item_discount_excluding_freebie <= 0
                  ? ''
                  : 'offers-boxs'
                  " type="text" :placeholder="$t('Enter Promo code')" aria-label="promocode" :disabled="verified_data &&
                    verified_data?.calculation &&
                    verified_data?.calculation
                      ?.item_discount_excluding_freebie > 0
                    " v-model="promocode" ref="promocode" />
                <a href="javascript:void(0)" @click="applyPromocode(promocode)" class="lnk" v-if="
                  !isPromocodeApply &&
                  verified_data?.calculation
                    ?.item_discount_excluding_freebie <= 0
                ">{{ $t("Apply") }}</a>
                <a href="javascript:void(0)" @click="
                  verified_data?.calculation
                    ?.item_discount_excluding_freebie > 0
                    ? removeItemPromocode()
                    : removePromocodeCall()
                  " class="lnk" v-else>{{ $t("Remove") }}</a>
              </div>

              <p v-if="promoError" class="promoerr">{{ promoError }}</p>

              <div class="delivery-details mt-4">
                <h6 class="mb-lg-2 mb-sm-2 mb-md-2 mb-2">Delivery details</h6>
                <div class="custom-radio-wrapper">
                  <label class="custom-radio" :class="restaurantData.delivery_type_time_slots == 1 ? 'ml-0' : ''
                    " v-if="
                      restaurantData.delivery_type_time_slots == 1 ||
                      restaurantData.delivery_type_time_slots == 2
                    ">
                    <input type="radio" v-model="delivery_type" value="1" :checked="delivery_type > 0" />
                    <span class="radio-checkmark"></span>
                    Delivery
                  </label>

                  <label class="custom-radio" :class="restaurantData.delivery_type_time_slots == 0 ? 'ml-0' : ''
                    " v-if="
                      (restaurantData.delivery_type_time_slots == 0 ||
                        restaurantData.delivery_type_time_slots == 2) &&
                      $auth?.setting?.is_pickup_enable
                    ">
                    <input type="radio" v-model="delivery_type" value="0" :checked="delivery_type <= 0" />
                    <span class="radio-checkmark"></span>
                    Takeaway
                  </label>
                </div>

                <!-- <div class="item">
                    <p v-if="selectedItem === 'item1'">Details about Item 1.</p>
                    <p v-if="selectedItem === 'item2'">Details about Item 2.</p>
                  </div> -->
              </div>

              <div class="review-boxs mt-4 delivery-time">
                <div class="d-flex justify-content-between align-items-center">
                  <h6 class="mb-0">
                    {{
                      delivery_type == 1
                        ? $t("Delivery Time")
                        : $t("Takeaway Time")
                    }}
                  </h6>
                  <delivery-time v-if="restaurantId > 0" ref="DeliveryTime" :isDelivery="delivery_type"
                    :restaurantId="restaurantId" :restaurantData="restaurantData"
                    v-on:setOrderTime="onSetOrderTime"></delivery-time>
                </div>
                <!-- <p
                  class="mb-0 mt-2"
                  v-if="this.scheduleDateTime && this.scheduleDateTime.time"
                >
                  {{
                    scheduleDateTime.time &&
                    scheduleDateTime.time != "" &&
                    scheduleDateTime.time != "asap"
                      ? scheduleDateTime.displayText
                      : isAsapEnable
                      ? restaurantData &&
                        (!isRestaurantClosed || !isSameDayDelivery)
                        ? $t("Select Time Slot")
                        : $t("As soon As possible")
                      : delivery_type == 1 
                      ? $t("Select delivery time")
                      : $t("Select takeaway time")
                  }}
                </p> -->
                <p v-if="
                  !order_schedule_time &&
                  isAsapEnable &&
                  delivery_type == 1 &&
                  this.isRestaurantClosed
                " class="mb-0 mt-2">
                  Deliver Now
                </p>
                <p v-else-if="
                  !order_schedule_time && isAsapEnable && delivery_type == 0
                " class="mb-0 mt-2">
                  TakeAway Now
                </p>
                <p v-else-if="displayDateTime && displayDateTime.displayText" class="mb-0 mt-2">
                  {{ displayDateTime.displayText }}
                </p>
                <p v-else class="mb-0 mt-2">Schedule Order</p>
              </div>

              <div class="delivery-instruction mt-4" v-if="delivery_type == 1">
                <h6 data-v-40b4bf5c="" class="mb-lg-3 mb-sm-3 mb-md-3 mb-2">
                  Delivery Instruction
                </h6>
                <div class="mobile-device-tab">
                  <ul class="">
                    <li class="mouse-hover">
                      <a :class="{ active: instructions.includes(1) }" @click="addDeliveryIntruction(1)">
                        <img src="../assets/images/icon_bell.svg" alt="icon_bell" class="" />
                        Avoid ringing bell</a>
                    </li>
                    <li class="mouse-hover">
                      <a :class="{ active: instructions.includes(2) }" @click="addDeliveryIntruction(2)">
                        <img src="../assets/images/icon_exit.svg" alt="icon_exit" class="" />
                        Leave at the door</a>
                    </li>
                    <li class="mouse-hover">
                      <a :class="{ active: instructions.includes(3) }" @click="addDeliveryIntruction(3)">
                        <img src="../assets/images/icon_avoid_calling.svg" alt="icon_exit" class="" />
                        Avoid calling</a>
                    </li>
                    <li class="mouse-hover">
                      <a :class="{ active: instructions.includes(4) }" @click="addDeliveryIntruction(4)">
                        <img src="../assets/images/icon_security.svg" alt="icon_security" class="" />
                        Leave with security</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="billing-data custom-checkbox" v-if="
              $auth.setting.contact_less_delivery &&
              delivery_type == 1 &&
              $auth.setting.is_pickup_enable
            ">
              <div class="d-flex justify-content-between align-items-center form-group">
                <h6>{{ $t("Opt in for No-contact Delivery") }}</h6>
                <input class="form-group" id="cntctdelivery" type="checkbox" true-value="1" false-value="0"
                  v-model="contactDelivery" />
                <label class="form-check-label" for="cntctdelivery"></label>
              </div>
              <p class="pcolor">
                {{
                  this.$auth.setting.terminology &&
                  $auth.setting.terminology[0].contact_less_delivery_text
                }}
              </p>
            </div>
            <div class="billing-data custom-checkbox custom-checkbox-nw" v-if="
              $auth.setting && $auth.setting.is_upload_order_image == 'Yes'
            ">
              <div class="d-flex justify-content-between align-items-center form-group">
                <h6>{{ $t($auth.setting.image_upload_text) }}</h6>
              </div>
              <div class="fileupload-main d-flex align-items-start">
                <label class="filelabel"><i class="fa fa-plus"></i><input multiple
                    accept="image/jpeg,image/png,image/jpg" @change="uploadImage" class="FileUpload1" id="FileInput"
                    type="file" /></label>
                <div v-if="images.length > 0" class="uploaded-img-main">
                  <div v-for="(img, key) in images" :key="key" class="prvie-img uploaded-img">
                    <p class="remove-flg" @click="removeUploadImage(img.id)">
                      X
                    </p>
                    <img :src="img.image" class="dis-img" />
                  </div>
                  <div class="text-center upload-loader" v-if="loading">
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                </div>
              </div>
            </div>
            <div id="billing-data" class="billing-data">
              <h6 class="mb-3">{{ $t("Billing Details") }}</h6>
              <ul>
                <li class="d-flex justify-content-between">
                  {{ $t("SubTotal") }}
                  <!-- <span>{{$t('(Including item')}}{{this.$auth.setting && this.$auth.setting.terminology && this.$auth.setting.terminology[0].tax_name}} <span v-html="$auth.setting.currency"></span>{{savedPrice()+')'}}</span> -->
                  <!-- <span><span v-html="$auth.setting.currency" class="currency"></span>{{getTotalItemAmount()}}</span> -->
                  <span><span v-html="$auth.setting.currency" class="currency"></span>{{
                    this.verified_data?.calculation?.subtotal ?? 0 }}</span>
                </li>
                <li class="d-flex justify-content-between" v-if="this.verified_data?.calculation?.packaging_charge > 0">
                  {{ $t("Packaging Charge") }}
                  <!-- <span><span v-html="$auth.setting.currency" class="currency"></span>{{pachageCharge()}}</span> -->
                  <span><span v-html="$auth.setting.currency" class="currency"></span>{{
                    this.verified_data?.calculation?.packaging_charge ?? 0
                  }}</span>
                </li>
                <li class="d-flex justify-content-between" v-if="$auth.setting && $auth.setting.cgst > 0">
                  {{ $t("CGST") }}({{ $auth.setting.cgst }}%)
                  <!-- <span><span v-html="$auth.setting.currency" class="currency"></span>{{parseFloat(cgstTotalAmount()).toFixed(2)}}</span> -->
                  <span><span v-html="$auth.setting.currency" class="currency"></span>{{
                    this.verified_data?.calculation?.CGST ?? 0 }}</span>
                </li>
                <li class="d-flex justify-content-between" v-if="$auth.setting && $auth.setting.sgst > 0">
                  {{ $t("SGST") }}({{ $auth.setting.sgst }}%)
                  <span><span v-html="$auth.setting.currency" class="currency"></span>{{
                    this.verified_data?.calculation?.SGST ?? 0 }}</span>
                </li>
                <li class="d-flex justify-content-between" v-if="$auth.setting && $auth.setting.igst > 0">
                  {{ $t("IGST") }}({{ $auth.setting.igst }}%)
                  <span><span v-html="$auth.setting.currency" class="currency"></span>{{
                    this.verified_data?.calculation?.IGST ?? 0 }}</span>
                </li>
                <!-- <li class="d-flex justify-content-between svprc" v-if="this.verified_data?.calculation?.saved > 0">
                  {{ $t("You Saved") }}
                  <span><span v-html="$auth.setting.currency" class="currency"></span>{{
                    this.verified_data?.calculation?.saved ?? 0 }}</span>
                </li> -->
                <li class="d-flex justify-content-between" v-if="
                  this.$auth.setting &&
                  (this.$auth.setting.included_tax == 0 ||
                    this.$auth.setting.included_tax == 'Yes')
                ">
                  {{
                    this.$auth.setting &&
                    this.$auth.setting.terminology &&
                    this.$auth.setting.terminology[0].tax_name
                  }}({{ this.gstMaxtax }}%)
                  <span><span v-html="$auth.setting.currency" class="currency"></span>{{
                    this.verified_data?.calculation?.total ?? 0 }}</span>
                </li>
                <li class="d-flex justify-content-between" :class="{
                  'delivry-li':
                    Number(this.delivery_charge) == 0 ||
                    this.delivery_charge == '',
                }">
                  {{ $t("Delivery Charges") }}
                  <span v-if="
                    Number(this.delivery_charge) == 0 ||
                    this.delivery_charge == ''
                  ">{{ $t("Free") }}</span>
                  <span v-else><span v-html="$auth.setting.currency" class="currency"></span>{{ this.delivery_charge
                    }}</span>
                </li>
                <li class="d-flex justify-content-between discount" v-if="promoDiscount">
                  {{ $t("Discount") }}
                  <span><span v-html="$auth.setting.currency" class="currency"></span>{{
                    this.verified_data?.calculation?.promocode_discount ?? 0
                  }}</span>
                </li>
                <li class="d-flex justify-content-between promo-discount" v-if="promoCashback">
                  <p>
                    {{ $t("Cashback") }}
                    <i v-b-tooltip.hover.right.nofade.v-danger="'This amount will be credited to your Chowman Wallet upon successful delivery of your order. You can use this amount in your next order.'
                      " class="fa fa-info-circle" aria-hidden="true"></i>
                  </p>
                  <span><span v-html="$auth.setting.currency" class="currency"></span>{{
                    this.verified_data?.calculation?.promocode_cashback ?? 0
                  }}</span>
                </li>

                <li class="d-flex justify-content-between bold">
                  {{ $t("To Pay") }}
                  <span><span v-html="$auth.setting.currency" class="currency"></span>{{
                    this.verified_data?.calculation?.total ?? 0 }}</span>
                </li>
              </ul>
              <div class="save-order-offer" v-if="this.verified_data?.calculation?.saved > 0">
                <!-- <img src="../assets/images/save-offer.svg" alt="" class="img-fuild" /> -->
                <span class="d-flex justify-content-center align-content-center">🥳 You saved &nbsp;
                  <p v-html="$auth.setting.currency" class="currency mb-0"></p>{{
                    this.verified_data?.calculation?.saved ?? 0 }}
                  on this order
                </span>
              </div>
              <!-- <li v-if="(isPickupDelivery == 1 ||isPickupDelivery  == -1)"><p class="pcolor">{{$auth.setting.terminology && $auth.setting.terminology[0].cart_info_text}}</p></li> -->
            </div>
            <div class="delivery-address plr15">
              <div class="d-flex align-items-center justify-content-between" v-if="delivery_type == 1">
                <h6 class="mb-0">
                  <span v-if="primaryAddress && primaryAddress.adress_clarification">{{
                    $t("Delivery To " + primaryAddress.adress_clarification)
                  }}</span>
                  <div v-if="this.address == ''" class="addaddrs">
                    <router-link :to="{ name: 'add-address' }">{{
                      $t("Add New Address")
                      }}</router-link>
                  </div>
                  <div v-if="addressList.length > 0" class="chng-addrs">
                    <a href="javascript:void(0)" @click="deliveryModalOpen" class="lnk">{{ $t("Change Address") }}</a>
                  </div>
                </h6>
                <p>{{ this.address }}</p>
              </div>
              <div v-if="delivery_type == 0" class="pckup-addr-cls">
                <div class="pic-cls-con">
                  <h6>
                    {{ $t("You will need to take away this order from") }}
                  </h6>
                  <p v-bind:title="restaurantData.location_address">
                    {{ this.restaurantData.address }}
                  </p>
                </div>
                <div class="map-add-cls">
                  <a :href="'https://www.google.com/maps?saddr=' +
                    latitude +
                    ',' +
                    longitude +
                    '&daddr=' +
                    restaurantLat +
                    ',' +
                    restaurantLong
                    " target="_blank">></a>
                </div>
              </div>
              <div class="full-btn">
                <a href="#billing-data" class="btn billing-btn view-dtail-cls"><span v-html="$auth.setting.currency"
                    class="currency"></span>{{ this.verified_data?.calculation?.total ?? 0
                  }}<span>{{ $t("View Bill Details") }}</span></a>
                <a v-if="
                  Number(this.verified_data?.calculation?.total ?? 0) <
                  parseInt(this.$auth.setting.min_order_value)
                " href="javascript:void(0);" class="prcc-cls">{{ $t("Minimum Order Value")
                  }}<span v-html="$auth.setting.currency" class="currency"></span>{{ this.$auth.setting.min_order_value
                  }}</a>
                <b-button variant="primary" class="review-cart-btn" disabled v-else-if="is_btn_spinner">
                  <b-spinner small type="grow"></b-spinner>
                  {{ $t("Loading") }}...
                </b-button>
                <a v-else href="javascript:void(0);" class="prcc-cls-blr green-btn"
                  style="border-radius:0 10px 10px 0 !important;" @click="processToPay()">{{
                    $t("Proceed To Pay") }}</a>
                <router-link ref="redirectPayment" style="display: none !important" :to="{ name: 'payment' }">{{
                  $t("Proceed To Pay") }}</router-link>
              </div>
            </div>
          </div>
          <!--------All Promocode Modal start---------->
          <div class="modal fade order-placed" id="promocodeModal" tabindex="-1" aria-labelledby="promocodeModallabel"
            aria-hidden="true" ref="promocodeModalRef" style="z-index: 9999">
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header">
                  <h4 class="modal-title" id="filterLabel">
                    {{ $t("Promocode") }}
                  </h4>
                  <a data-dismiss="modal" class="lnk">
                    <!-- {{ $t("Close") }} -->
                    <svg fill="#000000" width="25px" height="25px" viewBox="0 0 32 32" version="1.1"
                      xmlns="http://www.w3.org/2000/svg">
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                      <g id="SVGRepo_iconCarrier">
                        <path
                          d="M16 0c-8.836 0-16 7.163-16 16s7.163 16 16 16c8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 30.032c-7.72 0-14-6.312-14-14.032s6.28-14 14-14 14 6.28 14 14-6.28 14.032-14 14.032zM21.657 10.344c-0.39-0.39-1.023-0.39-1.414 0l-4.242 4.242-4.242-4.242c-0.39-0.39-1.024-0.39-1.415 0s-0.39 1.024 0 1.414l4.242 4.242-4.242 4.242c-0.39 0.39-0.39 1.024 0 1.414s1.024 0.39 1.415 0l4.242-4.242 4.242 4.242c0.39 0.39 1.023 0.39 1.414 0s0.39-1.024 0-1.414l-4.242-4.242 4.242-4.242c0.391-0.391 0.391-1.024 0-1.414z">
                        </path>
                      </g>
                    </svg>
                  </a>
                </div>
                <div class="modal-body text-center" v-if="promoCodes.length > 0">
                  <div class="order-item d-flex align-items-start justify-content-between"
                    v-for="(offers, index) in this.promoCodes" :key="index">
                    <div class="d-flex align-items-start">
                      <div class="smallimg-squre">
                        <img :src="offers.coupon_image" @error="imageErrorHandle"/>
                      </div>
                      <div class="order-data ml-3 d-flex align-items-start justify-content-between w-100">
                        <div class="orders-status-main">
                          <h6 class="mb-0">{{ offers.coupon_name }}</h6>
                          <p class="mt-1 prom-desc" :id="'shortdec' + offers.id" style="display: block">
                            {{ offers.description.substring(0, 54) }}
                            <a v-if="
                              offers.description &&
                              offers.description.length > 54
                            " href="javascript:void(0)" @click="readMore(offers.id)" class="readmore">...more</a>
                          </p>
                          <p :id="'moredesc' + offers.id" style="display: none" class="prom-desc">
                            {{ offers.description }}
                            <a href="javascript:void(0)" @click="readMore(offers.id)" class="readless">less</a>
                          </p>
                          <div class="promocode mt-2">
                            <p>
                              {{ $t("Code") }}:
                              <span class="m-promocode">{{
                                offers.coupon_code
                                }}</span>
                            </p>
                            <div class="copn-cl">
                              <a class="cart-btn" @click="applyPromocode(offers.coupon_code)">{{ $t("Apply") }}</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="modal-body text-center">
                  <p>{{ $t("No Offers Available") }}</p>
                </div>
              </div>
            </div>
          </div>
          <!--------All Promocode Modal End---------->
        </div>
        <div v-else class="order-items-main">
          <div class="full-btn">
            <div class="crt-img-cls">
              <img src="@/assets/images/empty cart.png" />
            </div>
            <p class="empty-cart">{{ $t("Cart Empty") }}</p>
            <a href="javascript:void(0)" @click="goToHome()">{{
              $t("Go Back")
              }}</a>
          </div>
        </div>
      </div>
    </section>
    <ProductDetails v-if="freeBie && freeBie.length > 0 && freeBieCoupon != '' && showFreeBie" :freeBie="true"
      @hideFreeBei="hideFreeBie" ref="childComponent" :restaurantID="freeBie[0].restaurant_id" :pagename="'itemslist'">
    </ProductDetails>

    <Footer></Footer>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import ProductDetails from "@/components/ProductDetails.vue";
import NavBar from "../components/NavBar.vue";
import moment from "moment";
import DeliveryTime from "../components/DeliveryTime.vue";
import Footer from "../components/Footer.vue";
import VueSkeletonLoader from "skeleton-loader-vue";
import LottieAnimation from "lottie-web-vue";
import { error_message, generateUUID,debounce, imageErrorHandle } from "../helper/helper";
import { error } from "jquery";
import Product from "../components/Product.vue";
import { CouponTypes } from "../helper/helper.js";

export default {
  components: {
    NavBar,
    DeliveryTime,
    Footer,
    "skeleton-loader-vue": VueSkeletonLoader,
    LottieAnimation,
    Product,
    ProductDetails,
  },
  data() {
    return {
      imageErrorHandle,imageErrorHandle,
      debounceApi:debounce(this.verifyCartData, 500),
      freeBieCoupon: "",
      showFreeBie: true,
      couponTypes: CouponTypes,
      selectedItem: null,
      selectedItem: "item1", // Set default to Item 1
      delivery_charge: "",
      verified_data: {},
      generateUUID: generateUUID,
      moment: moment,
      restaurantData: "",
      address: "",
      gstMaxtax: "",
      minimumOrder: "",
      cartItemCount: 1,
      promocode: "",
      promoError: "",
      promoDiscount: 0,
      isPromocodeApply: false,
      promoCashback: 0,
      promoCodeType: 0,
      contactDelivery: 0,
      place_order_parameter: {},
      shiping_id: "",
      coupon_id: "",
      instructions: [],
      notes: "",
      restaurantId: 0,
      scheduleDateTime: {},
      order_schedule_time: "",
      promoCodes: [],
      latitude: "",
      longitude: "",
      restaurantLat: "",
      restaurantLong: "",
      page: "review_page",
      isAsapEnable: false,
      timeFormat: "HH:mm:ss",
      isRestaurantClosed: false,
      isSameDayDelivery: false,
      is_btn_spinner: false,
      images: [],
      orderImagesId: "",
      loading: false,
      deliveryCharge: 0,
      displayDateTime: {},
      isAnimation: false,
      is_applied: false,
      delivery_type: 1,
      removeItemCoupon: false,
    };
  },
  watch: {
    delivery_type: function () {
      // this.verifyCartData();
      this.debounceApi();

    },
    cart: function () {
      this.debounceApi();
    },
  },
  mounted() {
    if (this.$auth.user) {
      this.token = this.$auth.user.token;
      this.userId = this.$auth.user.user_id;
      this.getRestaurantInfo();
      this.getAddress();
      if (!localStorage.getItem("latitude")) {
        navigator.geolocation.getCurrentPosition((position) => {
          this.latitude = position.coords.latitude;
          this.longitude = position.coords.longitude;
        });
      }
      let currentTime = moment().format(this.timeFormat);
      if (this.$auth.setting) {
        let system_start_time =
          this.$auth.setting && this.$auth.setting.system_start_time != ""
            ? this.$auth.setting.system_start_time.split(" ").pop()
            : "00:00:00";
        let system_end_time =
          this.$auth.setting && this.$auth.setting.system_end_time != ""
            ? this.$auth.setting &&
            this.$auth.setting.system_end_time.split(" ").pop()
            : "23:59:00";
        this.isSameDayDelivery =
          this.$auth.setting && this.$auth.setting.is_same_day_delivery == 0
            ? false
            : true;
        system_end_time =
          system_end_time == "00:00:00" ? "23:30:00" : system_end_time;
        let beforeTime = moment(system_start_time, this.timeFormat);
        let afterTime = moment(system_end_time, this.timeFormat);
        // if (
        //   moment(currentTime, this.timeFormat).isBetween(beforeTime, afterTime)
        // ) {
        //   this.isAsapEnable = true;
        // } else {
        //   this.isAsapEnable = false;
        // }
      }
      // let addOn = Number(this.restaurantData.time_slots)
      // this.displayDateTime = {
      //   date: moment().format("YYYY-MM-DD"),
      //   time: moment().add(30, "Minutes").format("HH:mm:ss"),
      //   displayText: moment().add(30, "Minutes").format("DD-MM-YYYY hh:mm A"),
      // };
      //   setTimeout(() => {
      //   this.verifyCartData();
      //   },1000)
    } else {
      this.$router.push({ name: "sign-in" });
    }
    if (
      localStorage.getItem("orderUploadImages") != "" &&
      localStorage.getItem("orderUploadImages") != null
    ) {
      this.images = JSON.parse(localStorage.getItem("orderUploadImages"));
    }
    if (
      !(
        this.freeBie &&
        this.freeBie.length > 0 &&
        this.freeBie[0].restaurant_id === this.cart[0]?.restaurant_id
      )
    ) {
      this.addFreeBieItem([]);
    }
  },

  computed: {
    ...mapGetters("product", ["cart", "freeBie", "offers"]),
    ...mapGetters("restaurant", ["restaurantDetails"]),
    ...mapGetters("address", ["addressList"]),
    ...mapGetters("order", ["isPickupDelivery"]),

    isFreeBieAvailable() {
      if (this.freeBie && this.freeBie.length > 0) {
        let itemID = this.freeBie[0].item_id;
        this.offers.forEach((e) => {
          if (
            e.items.includes(Number(itemID)) &&
            e.coupon_type == this.couponTypes.FREEBIE
          ) {
            if (
              this.verified_data?.calculation?.subtotal &&
              this.verified_data?.calculation?.subtotal >=
              e.minimum_order_amount
            ) {
              this.freeBieCoupon = e;
            }
          }
        });
      }
    },
    filterCart() {
      var array = [];
      this.isFreeBieAvailable;
      if (this.verified_data?.items?.length > 0) {
        this.verified_data.items.forEach((c) => {
          this.cart.forEach((e) => {
            //manage FreeBie
            // if (this.freeBie && this.freeBie.length > 0) {
            //   // if(c.id == this.freeBie[0].item_id && c.total_price <= 0 && c.promocode_id == this.freeBieCoupon){
            //   if (c.id == this.freeBie[0].item_id && c.promocode_id == this.freeBieCoupon.id) {
            //     this.showFreeBie = false;
            //   }
            // }
            // let check = true
            // if(e.offer.length > 0 && e.offer[0].id != c.promocode_id){
            //       check = false;
            // }
            const exists = array.some(
              (item) =>
                item.quantity === c.qty &&
                item.unit_price === c.unit_price &&
                item.total_price === c.total_price &&
                item.promocode_id === c.promocode_id &&
                item.cart_id === c.cart_id
            );
            if (c.id == e.item_id && !exists) {
              if (c.qty != 0) {
                array.push({
                  ...e,
                  quantity: c.qty,
                  unit_price: c.unit_price,
                  total_price: c.total_price,
                  promocode_id: c.promocode_id,
                  cart_id: c.cart_id,
                });
              }
            }
          });
        });
      }

      this.cartItemCount = array.length;
      this.removeFreeBie;
      return array;
    },
  },
  methods: {
    // price of one item after offer from verify-cart, same as app (free item keeps original price)
    unitPrice(item) {
      let price = Number(item.unit_price) > 0 ? Number(item.unit_price) : Number(item.price);
      return Number.isInteger(price) ? price : price.toFixed(2);
    },
    ...mapActions("product", [
      "removeProductFromCart",
      "verifyCart",
      "addFreeBieItem",
    ]),
    ...mapActions("address", ["getPrimaryAddress"]),
    ...mapActions("restaurant", ["getRestaurantDetails", "checkVendorRadius"]),
    ...mapActions("promocode", ["promocodeRedeem", "updatePromoCode"]),
    ...mapActions("order", [
      "postUploadOrderImages",
      "postremoveOrderImages",
      "getOrderDistancekm",
    ]),
    ...mapMutations("address", ["primaryAddress"]),
    ...mapMutations("order", [
      "placeOrderData",
      "clearPlaceOrderData",
      "chowmanPayPlaceOrder",
      "chowmanPayGiftPlaceOrder",
    ]),
    ...mapMutations("product", [
      "decrementProductInventary",
      "IncrementItemQuantity",
    ]),
    hideFreeBie(val) {
      this.showFreeBie = false;
    },

    operationTimeManage() {
      let time = [];
      if (this.delivery_type == 1) {
        time = this.restaurantData.delivered_timming || [];
      } else if (this.delivery_type == 0) {
        time = this.restaurantData.delivered_timming || [];
      }

      let today = moment().format("dddd");
      time.forEach((e) => {
        let currentTime = moment().format(this.timeFormat);
        let beforeTime = moment(e.open_time, this.timeFormat);
        let afterTime = moment(
          e.close_time == "00:00:00" ? "23:59:00" : e.close_time,
          this.timeFormat
        );
        if (
          e.day == today &&
          moment(currentTime, this.timeFormat).isBetween(
            beforeTime,
            afterTime
          ) &&
          e.status == 1
        ) {
          this.isAsapEnable = true;
          this.order_schedule_time = "";
          return;
        }
      });
    },
    openProductDeails(value) {
      window.$("#item-popup").modal("show");
      window.$("#item-popup").on("hidden.bs.modal", () => {
        this.$refs.childComponent.productDetail = null;
        this.$refs.childComponent.selectedCustomisation = {
          customize_type: {},
        };
      });
      this.$refs.childComponent.openProductModel(
        value.item_id,
        value.item_name
      );
    },

    redirectRestaurant() {
      this.$router.push({
        name: "restaurant-details",
        params: { restaurantId: btoa(this.restaurantData.restaurant_id) },
      });
    },
    clearCartItem() {
      this.$swal({
        title: this.$t("Are you sure you want to clear cart?"),
        type: "warning",
        customClass: {
          confirmButton: "cofirm-btn-new",
          cancelButton: "cancle-btn-new",
          title: "clear-cart-text mt-3 mb-1",
        },
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes"),
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store.commit("product/clearCartItems");
        }
      });
    },
    addDeliveryIntruction(type) {
      if (this.instructions.includes(type)) {
        this.instructions = this.instructions.filter(function (e) {
          return e != type;
        });
      } else {
        this.instructions.push(type);
      }
    },
    verifyCartData() {
      if (this.cart && this.cart.length <= 0) {
        return false;
      }

      var items_array = [];
      this.cart.forEach((e) => {
        items_array.push({
          id: Number(e.item_id),
          cart_id: this.generateUUID(),
          qty: Number(e.quantity),
          promocode_id:
            (e.offer &&
              e.offer.length &&
              (e.offer[0].coupon_type == this.couponTypes.FREEBIE ||
                !this.removeItemCoupon)) > 0
              ? e.offer[0].id
              : "",
          customisation:
            e.customisation && e.customisation.length <= 0
              ? null
              : e.customisation,
        });
      });

      // if(items_array.length <= 0){
      //     error_message('Invalid Cart');
      //     return;
      // }
      var data = {
        vendor_id: this.$auth.getVendorId(),
        customer: { id: this.userId },
        restaurant: {
          id: this.restaurantId,
        },
        address: { id: this.delivery_type == 1 ? this.shiping_id : "" },
        delivery_charge: this.delivery_type == 1 ? this.delivery_charge : "",
        promocode: { id: this.coupon_id },
        order_type: this.delivery_type,
        items: items_array,
      };

      this.verifyCart(data).then((data) => {
        if (data.code == 200) {
          this.verified_data = data?.Result ?? {};
          this.filterCart;
          this.delivery_charge =
            this.delivery_type == 1
              ? this.verified_data?.calculation?.delivery_charge
              : "";

          this.manageCartCount();

          let stop = false;
          this.verified_data.items.forEach((c) => {
            this.cart.forEach((e) => {
              if (this.freeBie && this.freeBie.length > 0) {
                if (
                  c.id == this.freeBie[0].item_id &&
                  c.promocode_id == this.freeBieCoupon.id
                ) {
                  stop = true;
                  this.hideFreeBie();
                  return;
                }
              }
            });
            if (stop) {
              return;
            }
          });

          if (
            !stop &&
            this.freeBie &&
            this.freeBie.length > 0 &&
            this.freeBieCoupon != "" && this.verified_data.calculation.subtotal > this.freeBieCoupon.minimum_order_amount
          ) {
            this.showFreeBie = true;
          }else{
            this.showFreeBie = false;
          }

          if (this.verified_data?.promocode?.id?.toString().length > 0) {
            //   this.promoCodeType = 1;
            this.promoDiscount =
              this.verified_data?.calculation?.promocode_discount;
            this.promoCashback =
              this.verified_data?.calculation?.promocode_cashback;
            this.isPromocodeApply = true;
            this.getPromoModal(this.promoCodeType);
          } else {
            // coupon sent but not applied by verify-cart (check before removePromocode clears coupon_id)
            let isRejected = this.coupon_id.toString().length > 0;
            this.removePromocode();
            if (isRejected) {
              this.isAnimation = false;
              if (this.is_applied) {
                this.is_applied = false;
                this.$swal("Invalid Promocode.");
              }
            }
          }
          if (
            this.verified_data?.calculation?.item_discount_excluding_freebie > 0
          ) {
            this.isPromocodeApply = true;
            // Save ₹90 on this order
            this.promocode = `You Saved ${this.verified_data?.calculation?.item_discount_excluding_freebie} Rupees`;
          }
        } else {
          this.isAnimation = false;
        }
      });
    },
    manageCartCount() {
      if (this.verified_data?.items?.length > 0) {
        this.verified_data.items.forEach((c) => {
          this.cart.forEach((e, index) => {
            // isPromocodeApply
            if (c.id == e.item_id && c.qty == 0) {
              this.$store.dispatch("product/removeProductFromCart", index);
            }
          });
        });
      } else {
        this.$store.commit("product/clearCartItems");
      }
    },
    deliveryModalOpen() {
      $(".location-modal").addClass("heightModal");
      this.$refs.getaddressdata.AddressesList();
      $("#deliveryModal").modal("show");
    },

    //Promocode modal
    promocodeModal() {
      let deliveryType = "Delivery";
      if (this.delivery_type == 1) {
        deliveryType = "Delivery";
      } else {
        deliveryType = "Pickup";
      }
      this.updatePromoCode({
        vendor_id: this.$auth.getVendorId(),
        coupon_type: deliveryType,
        restaurant_id: this.restaurantData.restaurant_id,
        user_id: this.userId ?? null,
      }).then((data) => {
        if (data.code == 200) {
          this.promoCodes = data.Result;
        }
        $("#promocodeModal").modal("show");
      });
    },

    onSetOrderTime(value) {
      this.scheduleDateTime = value;
      this.order_schedule_time = value;
      this.displayDateTime = value;
    },

    //Get address for API call
    getAddress() {
      this.delivery_charge = "";
      this.getPrimaryAddress({}).then((data) => {
        if (data.code == 200) {
          this.shiping_id = data.Result.shiping_id;
          this.address =
            (data.Result.flat_no ? data.Result.flat_no : "") +
            " " +
            (data.Result.house_name ? data.Result.house_name : "") +
            " " +
            data.Result.Shiping_address;
          //   this.getDeliveryChrge();
          //   this.verifyCartData();
          this.primaryAddress = data.Result;
          this.$store.commit("address/primaryAddress", data.Result);
        } else {
          this.address = "";
          this.$store.commit("address/primaryAddress", "");
        }
        this.verifyCartData();
      });
    },

    //Get Restaurant Information
    getRestaurantInfo() {
      if (this.cart.length) {
        this.restaurantId = this.cart[0].restaurant_id;
        this.getRestaurantDetails({
          vendor_id: this.$auth.getVendorId(),
          restaurant_id: this.restaurantId,
          is_langauge: this.$store.state.lang.locale,
        }).then((data) => {
          if (data.code == 200) {
            this.restaurantData = data.Result;
            this.restaurantId = this.restaurantData.restaurant_id;
            this.restaurant_service_tax = data.Result.restaurant_service_tax;
            this.restaurantLat = data.Result.latitude;
            this.restaurantLong = data.Result.longitude;
            this.operationTimeManage();

            if (
              this.restaurantData &&
              this.restaurantData.delivery_type_time_slots &&
              this.restaurantData.delivery_type_time_slots == 0
            ) {
              this.delivery_type = 0;
            }
            this.isRestaurantClosed =
              data.Result.restaurant_on_off == "0" ? false : true;
            //   this.getDeliveryChrge();
          }
        });
      }
    },

    //Increament Item
    plusItem(item, index) {
      if (item.itemTotalQuantity > item.quantity) {
        this.$store.commit("product/IncrementItemQuantity", index);
        //   this.getDeliveryChrge();
        this.debounceApi();
      } else {
        this.$swal("Chowman", "Maximum items reached");
      }
    },

    //Decrement Item
    minusItem(cartProduct, index) {
      let array = [...this.cart];
      const idx = array.findIndex((item) => {
        return (
          item.quantity === cartProduct.quantity &&
          item.offer === cartProduct.offer &&
          item.item_id === cartProduct.item_id
        );
      });
      // console.log(idx,"indexindex")
      let indx = index
      if (Number(idx) && idx != index && idx >= 0) {
        indx = idx;
      }
      if (cartProduct.quantity == "1" || cartProduct.quantity == "0") {
        this.deleteProduct(indx);
      } else {
        this.$store.commit("product/decrementProductInventary", indx);
        //   this.getDeliveryChrge();
      }
      this.debounceApi();
    },

    //Remove Item from cart
    deleteProduct: function (index) {
      this.$store.commit("order/clearPlaceOrderData");
      this.$store.dispatch("product/removeProductFromCart", index);
    },

    //Delivery Charge Total Amount Display
    //   getDeliveryChrge() {
    //       let vardeliveryCharge = 0;
    //       if (this.isPickupDelivery == 1 || this.isPickupDelivery == -1) {
    //           if (this.$auth.setting && this.$auth.setting.delivery_charges_type == "Distance") {
    //               let unit = "K";
    //               if (this.$auth.setting && this.$auth.setting.distance_metric == "Miles") {
    //                   unit = "N";
    //               }
    //               let clntLatlng = this.primaryAddress;
    //               let restLatlng = this.restaurantDetails;
    //               if (clntLatlng.latitude != undefined && clntLatlng.longitude != undefined && restLatlng.latitude != undefined && restLatlng.longitude != undefined) {
    //               this.getDeliveryLocation(clntLatlng.latitude, clntLatlng.longitude, restLatlng.latitude, restLatlng.longitude, unit);
    //               }
    //           } else if (this.$auth.setting && this.$auth.setting.delivery_charges_type == "Amount") {
    //               let checkValue = false;
    //               if(this.$auth.setting && this.$auth.setting.charges != undefined){
    //                   this.$auth.setting.charges.forEach(charge => {
    //                       if (charge.min_value < parseInt(this.getTotalItemAmount()) && parseInt(this.getTotalItemAmount()) <= charge.max_value) {
    //                           vardeliveryCharge = charge.delivery_charges;
    //                           checkValue = true;
    //                       }
    //                   });
    //               }
    //               // if(!checkValue){
    //               //     vardeliveryCharge = this.$auth.setting.charges[0].delivery_charges;
    //               // }
    //           }
    //       } else {
    //           vardeliveryCharge = 0;
    //       }
    //       this.deliveryCharge = vardeliveryCharge;
    //   },

    //Get Delivery Location Distance Find
    //   getDeliveryLocation(lat1, lon1, lat2, lon2, unit) {
    //       if (this.$auth.setting){
    //           let dist = 0;
    //           let charges = this.$auth.setting.charges;
    //           if (lat1 != undefined && lon1 != undefined && lat2 != undefined && lon2 != undefined) {
    //           this.getOrderDistancekm({
    //               vendor_id: this.$auth.getVendorId(),
    //               useraddress_latitude: lat1,
    //               useraddress_longitude: lon1,
    //               store_latitude: lat2,
    //               store_longitude: lon2,
    //           }).then((data) => {
    //               if (data.code == 200) {
    //                   let distancekm = data.Result.distance_km;
    //                   let checkKM = false;
    //                   charges.forEach(charge => {
    //                       if (charge.min_value < distancekm && distancekm <= charge.max_value) {
    //                           dist = charge.delivery_charges;
    //                           checkKM = true;
    //                       }
    //                   });
    //                   if(!checkKM){
    //                       dist = this.$auth.setting.charges[0].delivery_charges;
    //                   }
    //                   this.deliveryCharge = dist;
    //               }else{
    //                   this.deliveryCharge = 0;
    //               }
    //           });
    //           }else{
    //               this.deliveryCharge = 0;
    //           }
    //       }
    //   },

    //Grand Total Amount Display
    //   getTotalAmount() {
    //       let gstTotalPrice = 0;
    //       if (this.$auth.setting && (this.$auth.setting.included_tax == 0 || this.$auth.setting.included_tax == 'Yes')) {
    //           gstTotalPrice = parseFloat(this.gstTotalAmount());
    //       }
    //       let totalItemPrice = parseFloat(this.getTotalItemAmount());
    //       //let deliveryTotalPrice = parseFloat(this.deliveryCharge);
    //       let deliveryTotalPrice = 0;
    //       let grandTotal = parseFloat(totalItemPrice + gstTotalPrice + deliveryTotalPrice - this.promoDiscount + this.verified_data?.calculation?.packaging_charge + this.cgstTotalAmount() + this.sgstTotalAmount()+ this.igstTotalAmount()).toFixed(2);
    //       return grandTotal;
    //   },

    getPromoModal(type) {
      var html = "";
      let currency = "";
      if (
        document.getElementById("currency") &&
        document.getElementById("currency").childNodes[0]
      ) {
        currency =
          document.getElementById("currency").childNodes[0].textContent;
      }
      // same message as app, amounts from verify-cart calculation
      let amount = (value) => '<span class="currency">' + currency + "</span>" + value;
      let discount = Number(this.promoDiscount) > 0;
      let cashback = Number(this.promoCashback) > 0;
      let message = "";
      if (discount && cashback) {
        message = "You got " + amount(this.promoDiscount) + " Discount, and you will receive " + amount(this.promoCashback) + " Cashback on this order.";
      } else if (discount) {
        message = "You got " + amount(this.promoDiscount) + " Discount on this order.";
      } else if (cashback) {
        message = "You will receive " + amount(this.promoCashback) + " Cashback on this order.";
      }
      html =
        '<span class="text-black">' + message + '</span><br><span class="pm-txt">' +
        (this.$auth.setting.promocode_text || "Hooray! your coupon has been applied successfully") +
        "</span>";
      if (this.is_applied) {
        this.is_applied = false;
        this.$swal({
          icon: "success",
          showCloseButton: true,
          showConfirmButton: false,
          html: html,
        }).then(() => {
          this.isAnimation = false;
        });
      }
    },

    //Apply Promocode For function
    applyPromocode(code) {
      let currency = "";
      if (
        document.getElementById("currency") &&
        document.getElementById("currency").childNodes[0]
      ) {
        currency =
          document.getElementById("currency").childNodes[0].textContent;
      }
      this.promoCashback = "";
      this.promoDiscount = "";

      let deliveryType = "Delivery";
      if (this.delivery_type == 1) {
        deliveryType = "Delivery";
      } else {
        deliveryType = "Pickup";
      }

      if (
        this.verified_data &&
        this.verified_data?.calculation &&
        this.verified_data?.calculation?.item_discount_excluding_freebie
      ) {
        this.promocode = "";
        this.isPromocodeApply = false;
        this.removeItemCoupon = true;
      }
      this.promocode = code;
      this.$refs.promocode.value = code;
      if (this.$refs.promocode.value) {
        this.promocodeRedeem({
          user_id: this.userId,
          vendor_id: this.$auth.getVendorId(),
          is_langauge: this.$store.state.lang.locale,
          original_price: this.verified_data?.calculation?.subtotal,
          coupon_code: this.$refs.promocode.value,
          coupon_type: deliveryType,
          restaurant_id: this.restaurantData.restaurant_id,
        }).then((data) => {
          this.is_applied = true;
          if (data.code == 200) {
            let result = data.Result;
            // API already checks min order value (city wise / customer category / default rule)
            // and returns 101 with message, result.minimum_order_amount is only default rule value
            this.isAnimation = true;
            this.coupon_id = result.id;
            this.promoCodeType = Number(result.is_flat_discount);
            this.verifyCartData();
          } else if (data.code == 101) {
            this.promoError = data.msg;
            this.removePromocode();
            setTimeout(() => (this.promoError = false), 3000);
          }
        });
      } else {
        this.promoError = this.$t("Please Enter Promocode");
        setTimeout(() => (this.promoError = false), 3000);
      }
      this.isAnimation = false;
      $("#promocodeModal").modal("hide");
    },
    removeItemPromocode() {
      this.promocode = "";
      this.isPromocodeApply = false;
      this.removeItemCoupon = true;
      this.verifyCartData();
    },
    removePromocodeCall() {
      if (this.promocode != "") {
        this.$refs.promocode.value = "";
      }
      this.coupon_id = "";
      this.promocode = "";
      this.isPromocodeApply = false;
      this.promoDiscount = 0;
      this.promoCashback = 0;

      this.verifyCartData();
      // this.removePromocode();
    },

    //Remove Apply Code
    removePromocode() {
      if (this.promocode != "") {
        this.$refs.promocode.value = "";
      }
      this.coupon_id = "";
      this.promocode = "";
      this.isPromocodeApply = false;
      this.promoDiscount = 0;
      this.promoCashback = 0;
    },

    processToPay() {
      if (this.delivery_type == 1) {
        if (this.shiping_id == "") {
          this.$toasted.error(this.$t("Please select or add address"), {
            duration: 2000,
          });
          return false;
        }
      } else {
        this.shiping_id = "";
      }
      this.is_btn_spinner = true;
      //if (!this.isAsapEnable ||!this.isRestaurantClosed ||!this.isSameDayDelivery) {
      //if (
      //!this.scheduleDateTime.time ||
      //this.scheduleDateTime.time == "" ||
      //this.scheduleDateTime.time == "asap"
      //) {
      // this.$refs.DeliveryTime.openTime();
      //this.is_btn_spinner = false;
      //return false;
      //}
      //}

      if (
        (!this.isAsapEnable || !this.isRestaurantClosed) &&
        !this.order_schedule_time
      ) {
        this.$refs.DeliveryTime.openTime();
        this.is_btn_spinner = false;
        return false;
      }

      if (this.$auth.user) {
        let future_delivery_date = "";
        if (this.scheduleDateTime) {
          if (
            this.scheduleDateTime.time &&
            this.scheduleDateTime.time != "asap"
          ) {
            //Schedule order
            future_delivery_date =
              this.scheduleDateTime.date + " " + this.scheduleDateTime.time;
          }
        }
        this.order_schedule_time = future_delivery_date;
        // let deliveryType = "Delivery";
        // if (this.isPickupDelivery == 1 || this.isPickupDelivery == -1) {
        //   deliveryType = "Delivery";
        // } else {
        //   deliveryType = "Pickup";
        // }

        var items_array = [];
        this.filterCart.forEach((e) => {
          let cust =
            e.customisation && e.customisation.length > 0
              ? e.customisation
              : null;
          items_array.push({
            id: Number(e.item_id),
            cart_id: e.cart_id,
            qty: Number(e.quantity),
            total: e.total_price,
            promocode_id: e.promocode_id,
            customisation: cust,
          });
        });

        if (items_array.length <= 0) {
          error_message("Invalid Cart");
          return;
        }

        this.place_order_parameter = {
          vendor_id: this.$auth.getVendorId(),
          customer: { id: this.userId },
          restaurant: {
            id: this.restaurantId,
          },
          address: { id: this.delivery_type == 1 ? this.shiping_id : "" },
          delivery_charge: this.delivery_charge,
          promocode: { id: this.coupon_id },
          order_type: this.delivery_type,
          items: items_array,
          order_time: future_delivery_date,
          notes: this.notes,
          delivery_instruction:
            this.delivery_type == 1 ? this.instructions : [],
          calculation: this.verified_data.calculation,
          device: {
            type: "WEB",
          },
        };

        this.$store.commit("order/chowmanPayPlaceOrder", {});
        this.$store.commit("order/chowmanPayGiftPlaceOrder", {});
        if (this.delivery_type == 1) {
          this.checkRestaurantRadius();
        } else {
          this.is_btn_spinner = false;
          this.$store.dispatch(
            "order/placeOrderData",
            this.place_order_parameter
          );
          this.$refs.redirectPayment.$el.click();
        }
        // this.is_btn_spinner= false;
        // this.$store.dispatch("order/placeOrderData",this.place_order_parameter);
        // this.$refs.redirectPayment.$el.click();
      } else {
        this.$router.push({ name: "sign-in" });
      }
    },

    checkRestaurantRadius() {
      let vm = this;
      this.checkVendorRadius({
        is_langauge: this.$store.state.lang.locale,
        latitude:
          this.primaryAddress.latitude && this.primaryAddress.latitude == ""
            ? this.primaryAddress.latitude
            : parseFloat(localStorage.getItem("latitude")),
        longitude:
          this.primaryAddress.longitude && this.primaryAddress.longitude == ""
            ? this.primaryAddress.longitude
            : parseFloat(localStorage.getItem("longitude")),
        restaurant_id: this.restaurantId,
        vendor_id: this.$auth.getVendorId(),
      })
        .then((data) => {
          if (data.code == 200) {
            this.is_btn_spinner = false;
            this.$store.dispatch(
              "order/placeOrderData",
              this.place_order_parameter
            );
            this.$refs.redirectPayment.$el.click();
          } else {
            this.$swal(
              "Chowman",
              "<span>Oops! We do not deliver at your selected location.</span> <br>Click below to change address"
            );
            this.is_btn_spinner = false;
            return false;
          }
        })
        .catch(function () {
          vm.$swal("Chowman", "Something went wrong, Please try again");
          vm.is_btn_spinner = false;
          return false;
        });
    },

    goToHome() {
      if (this.restaurantData) {
        this.$router.push({
          name: "restaurant-details",
          params: { restaurantId: btoa(this.restaurantData?.restaurant_id) },
        });
      } else {
        this.$router.push({ name: "Home" });
      }
      //   if(this.restaurantData){
      //       this.$router.push({ name: "vendor", params: {delivery_type:(this.isPickupDelivery == '1'?'delivery':this.isPickupDelivery == '0'?'takeaway':this.isPickupDelivery == '2'?'reservation':''), restaurant_name: this.restaurantData.slug } });
      //   }else{
      //       // this.$router.push({ name: "Home" });
      //       this.$router.push({ name: this.isPickupDelivery == '2'?'reservation':'Home'});
      //   }
    },

    //Order Image Upload
    uploadImage(e) {
      let vm = this;
      var selectedFiles = e.target.files;
      var formData = new FormData();
      var totalImg = selectedFiles.length + this.images.length;
      if (totalImg > this.$auth.setting.order_image_upload_limit) {
        this.$toasted.error(
          this.$t("You have reached max image upload limit"),
          { duration: 2000 }
        );
      } else {
        this.loading = true;
        this.is_btn_spinner = true;
        for (let i = 0; i < selectedFiles.length; i++) {
          formData.append("image[" + i + "]", selectedFiles[i]);
        }
        this.postUploadOrderImages(formData).then((data) => {
          if (data.code == 200) {
            let imagesArray = data.imagedata;
            if (
              localStorage.getItem("orderUploadImages") != "" ||
              localStorage.getItem("orderUploadImages") != null
            ) {
              imagesArray.forEach((imgdata) => {
                this.images.push(imgdata);
              });
            } else {
              this.images = imagesArray;
            }
            localStorage.setItem(
              "orderUploadImages",
              JSON.stringify(this.images)
            );
            let ordImg = [];
            this.images.forEach((imgid) => {
              ordImg.push(imgid.id);
            });
            this.orderImagesId = ordImg.join(",");
            this.loading = false;
            this.is_btn_spinner = false;
          } else {
            this.is_btn_spinner = false;
            this.loading = false;
          }
        });
      }
    },

    //Remove uplod image from
    removeUploadImage(id) {
      if (confirm(this.$t("Are you sure you want to delete?"))) {
        this.loading = true;
        this.is_btn_spinner = true;
        this.postremoveOrderImages({
          imageid: id,
        }).then((data) => {
          if (data.code == 200) {
            localStorage.setItem("orderUploadImages", "");
            let ordImg = [];
            this.orderImagesId = "";
            var rIndex = this.images.findIndex((r) => r.id == id);
            this.images.splice(rIndex, 1);
            this.images.forEach((imgid) => {
              ordImg.push(imgid.id);
            });
            localStorage.setItem(
              "orderUploadImages",
              JSON.stringify(this.images)
            );
            this.orderImagesId = ordImg.join(",");
            this.loading = false;
            this.is_btn_spinner = false;
          }
        });
      }
    },

    readMore(value) {
      $("#moredesc" + value).toggle(400);
      $("#shortdec" + value).toggle(400);
    },
  },
};
</script>

<style scoped>
.reviewCart .media-itms {
  display: block;
  margin-bottom: 15px;
}

.reviewCart .media-itms:last-child {
  margin-bottom: 0;
}

.number {
  background: #ddd6d6;
}

.animationCls {
  position: absolute;
  top: 0;
  left: 50%;
  translate: -50% -0%;
  width: 100vw;
  height: 100vh;
  z-index: 1;
}

.svprc span {
  color: #27ae60;
}

.delivery-address {
  padding: 15px;
}

.delivry-li,
.delivry-li span {
  color: green;
}

button.btn.btn-primary.disabled,
.prcc-cls-blr,
.prcc-cls,
.prcc-cls:hover,
.prcc-cls-blr:hover {
  background: #27ae60;
  border: none;
  border-radius: 0 10px 10px 0 !important;
}

@media only screen and (max-width: 767px) {
  .delivery-address p {
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    display: -webkit-box;
  }
}
</style>
